import React from "react";

/**
 * Breadcrumb display component (non-clickable).
 * Shows the navigation path but does not navigate.
 */
const Breadcrumb = ({ path = [] }) => {
  if (!path || path.length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
        padding: "4px 0",
        background: "transparent",
        borderRadius: "0",
        marginBottom: "0",
        flexWrap: "wrap",
      }}
    >
      {path.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <span
              style={{
                color: "#94a3b8",
                fontSize: "12px",
                fontWeight: 500,
                margin: "0 -4px",
              }}
            >
              /
            </span>
          )}
          <span
            style={{
              background: "transparent",
              color: index === path.length - 1 ? "#009f8d" : "#94a3b8",
              border: "none",
              padding: "4px 8px",
              fontSize: "12px",
              fontWeight: 600,
              whiteSpace: "nowrap",
              cursor: "default",
              userSelect: "none",
            }}
          >
            {item.label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
